/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SAMLProviderPartialUpdate
 */
export interface SAMLProviderPartialUpdate {
    /**
     * 
     * @type {string}
     * @memberof SAMLProviderPartialUpdate
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SAMLProviderPartialUpdate
     */
    entityId?: string;
    /**
     * 
     * @type {string}
     * @memberof SAMLProviderPartialUpdate
     */
    ssoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SAMLProviderPartialUpdate
     */
    sloUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SAMLProviderPartialUpdate
     */
    certificate?: string;
    /**
     * 
     * @type {string}
     * @memberof SAMLProviderPartialUpdate
     */
    spCertificate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SAMLProviderPartialUpdate
     */
    spCertificateKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SAMLProviderPartialUpdate
     */
    nameidFormat?: SAMLProviderPartialUpdateNameidFormatEnum;
}

/**
* @export
* @enum {string}
*/
export enum SAMLProviderPartialUpdateNameidFormatEnum {
    _11nameidFormatunspecified = 'urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified',
    _11nameidFormatemailAddress = 'urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress',
    _20nameidFormatpersistent = 'urn:oasis:names:tc:SAML:2.0:nameid-format:persistent',
    _11nameidFormatWindowsDomainQualifiedName = 'urn:oasis:names:tc:SAML:1.1:nameid-format:WindowsDomainQualifiedName',
    _11nameidFormatX509SubjectName = 'urn:oasis:names:tc:SAML:1.1:nameid-format:X509SubjectName',
    _20nameidFormatkerberos = 'urn:oasis:names:tc:SAML:2.0:nameid-format:kerberos',
    _20nameidFormatentity = 'urn:oasis:names:tc:SAML:2.0:nameid-format:entity',
    _20nameidFormattransient = 'urn:oasis:names:tc:SAML:2.0:nameid-format:transient',
    _20nameidFormatencrypted = 'urn:oasis:names:tc:SAML:2.0:nameid-format:encrypted'
}

export function SAMLProviderPartialUpdateFromJSON(json: any): SAMLProviderPartialUpdate {
    return SAMLProviderPartialUpdateFromJSONTyped(json, false);
}

export function SAMLProviderPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAMLProviderPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'entityId': !exists(json, 'entity_id') ? undefined : json['entity_id'],
        'ssoUrl': !exists(json, 'sso_url') ? undefined : json['sso_url'],
        'sloUrl': !exists(json, 'slo_url') ? undefined : json['slo_url'],
        'certificate': !exists(json, 'certificate') ? undefined : json['certificate'],
        'spCertificate': !exists(json, 'sp_certificate') ? undefined : json['sp_certificate'],
        'spCertificateKey': !exists(json, 'sp_certificate_key') ? undefined : json['sp_certificate_key'],
        'nameidFormat': !exists(json, 'nameid_format') ? undefined : json['nameid_format'],
    };
}

export function SAMLProviderPartialUpdateToJSON(value?: SAMLProviderPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'entity_id': value.entityId,
        'sso_url': value.ssoUrl,
        'slo_url': value.sloUrl,
        'certificate': value.certificate,
        'sp_certificate': value.spCertificate,
        'sp_certificate_key': value.spCertificateKey,
        'nameid_format': value.nameidFormat,
    };
}


